import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store, persistor } from './core/store';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react';
import moment from 'moment';
import 'moment/locale/es';

import './i18n';
import './ui/styles/app-base.scss';
import './ui/styles/app-base.css';
import './ui/styles/app-components.css';
import './ui/styles/app-utilities.css';
import 'remixicon/fonts/remixicon.css'
import '@fontsource/inter';

import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/src/sweetalert2.scss';
import 'react-photo-view/dist/react-photo-view.css';

moment.locale('es');

// Benign browser warning; CRA's overlay treats it as a fatal runtime error.
window.addEventListener('error', (event) => {
  if (event.message?.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);

reportWebVitals();
